// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"styles_iconWrapper__27_U4","closeIconWrapper":"styles_closeIconWrapper__2l7rB"};